export function normalizePokemonRef(value) {
  return String(value || "").trim().toLowerCase();
}

export function getPokemonSpriteUrl(id) {
  return `https://raw.githubusercontent.com/PokeAPI/sprites/master/sprites/pokemon/other/official-artwork/${id}.png`;
}

export function getPrimaryType(types = []) {
  return types.find((pokemonType) => pokemonType.slot === 1)?.type?.name;
}

export function getStatValue(stats = [], statKey) {
  return stats.find((pokemonStat) => pokemonStat.stat.name === statKey)?.base_stat ?? 0;
}

export function getStatFillPercentage(baseStat) {
  const parsedStat = Number(baseStat) || 0;
  const normalizedStat = Math.max(0, parsedStat);
  const maxPokemonStat = 255;
  return Math.min((normalizedStat / maxPokemonStat) * 100, 100);
}
